import React from 'react';
import DOMPurify from 'dompurify';

const DocumentationCategories = (props) => {
    const [openCategoryIndex, setOpenCategoryIndex] = React.useState(0);
    const searchData = (items) => {
        const result = []
        if (!props.data.search) return items;
        const seachStr = props.data.search.toLowerCase();
        items.forEach((docItem) => {
            if (docItem.first_locale.name.toLowerCase().search(seachStr) === -1) {
                var result_item = { ...docItem };
                result_item.documentations = [];
                docItem.documentations.forEach((item) => {
                    var res = item.name.toLowerCase().search(seachStr)
                    if (res === -1 && item.content) {
                        res = item.content.toLowerCase().search(seachStr)
                    }

                    if (res > -1) {
                        result_item.documentations.push(item)
                    }
                });

                if (result_item.documentations.length) result.push(result_item)
            }
            else {
                result.push(docItem)
            }
        })
        return result
    }
    
    return (
        <>
            {searchData(props.items).map((docItem, index) => {
                return (
                    <div key={'dq_' + index} className={'categories mb-1 pl-md-4 py-3 px-4 py-md-0 px-md-0' + (openCategoryIndex === index ? ' isActive' : '')}>
                        {
                            docItem?.first_locale ?
                            <>
                                <button data-test-id={"doc-category-" + index} type="button" className="categories-btn text-medium text-color-changeable text-bold text-sm-left w-sm-100"
                                    onClick={() => {
                                        setOpenCategoryIndex(openCategoryIndex === index ? -1 : index)
                                    }}>{docItem.first_locale.name}</button>
                                <ul className={'categories-list mt-3 mt-md-0' + (openCategoryIndex === index ? ' isActive' : '')}>
                                    {docItem.documentations.map((item, subindex) => {
                                        return <li key={'s_' + subindex}
                                            data-test-id={"doc-category-" + index + "-item-" + subindex}
                                            className={'d-flex categories-link text-small text-semibold list-style-inside mb-3 mb-md-0' + (props?.dark ? ' text-white' : '')}
                                            onClick={() => {
                                                props.data.setContent(item.content)
                                            }}
                                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.name) }}></li>
                                    })}
                                </ul>
                            </>
                            : null
                        }
                    </div>
                )
            })}
        </>
    )
}

export default DocumentationCategories;
